import * as React from "react";
function SvgthreedotIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="1.5" cy="1.5" r="1.5" fill="#C4C4C4" />
            <circle cx="6.5" cy="1.5" r="1.5" fill="#C4C4C4" />
            <circle cx="11.5" cy="1.5" r="1.5" fill="#C4C4C4" />
        </svg>;
}
export default SvgthreedotIcon;